import React, {useState} from "react";
import Modal from 'react-overlays/Modal';
import "./Notification.css";

const Backdrop = (props: {[id: string]: any}) => {
  return <div className="backdrop" {...props} />;
}

interface INotificationProps {
  title: string;
  body: string;
}

export const Notification = (props: INotificationProps) => {
  const {body, title} = props;
  const [openState, setOpenState] = useState<boolean>(true);
  const onClose = () => {
    setOpenState(false);
  };

  const modalBody = <div>
    <h3 className="title">{title}</h3>
    <p className="body">{body}</p>
  </div>;
  // <button className="flat">OK</button>
  // const body2 = <p><h3>{title}</h3> {body}</p>;


  return (
    <Modal className="modal"
      show={openState}
      onHide={onClose}
      renderBackdrop={Backdrop}
    >
      {modalBody}
    </Modal>
  );
}
